(function () {
  'use strict';

  /* @ngdoc object
   * @name missingEtsReport
   * @description
   *
   */
  angular
    .module('missingEtsReport', [
      'ui.router'
    ]);
}());
